var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ActionsButton",
    on: {
      "blur": _vm.closeActions
    }
  }, [_c('button', {
    staticClass: "ActionsButton-button",
    style: {
      color: _vm.color
    },
    attrs: {
      "id": ("js-actions-button-" + (_vm.actionsButtonId)),
      "aria-label": _vm.$t('actionsButton.options'),
      "tabindex": "0"
    },
    on: {
      "blur": function ($event) {
        _vm.hovered = false;
      },
      "click": _vm.buttonClicked,
      "focus": function ($event) {
        _vm.hovered = true;
      },
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buttonClicked.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        return _vm.buttonClicked.apply(null, arguments);
      }],
      "mouseleave": function ($event) {
        _vm.hovered = false;
      },
      "mouseover": function ($event) {
        _vm.hovered = true;
      }
    }
  }, [_c('span', {
    staticClass: "js-actions-button ActionsButton-icon common-option-menu"
  })]), _c('transition', {
    attrs: {
      "mode": "out-in",
      "name": "translateY"
    }
  }, [_vm.dropdownDisplayed ? _vm._t("default", null, {
    "id": "js-dropdown-animated"
  }) : _vm._e()], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }